/* Generic snap carousel: prev/next buttons scroll one slide (port of HeroSlider/UGC scroll behaviour). */
if (!customElements.get('carousel-slider')) {
  customElements.define(
    'carousel-slider',
    class CarouselSlider extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const step = (dir) => {
          const slide = track.firstElementChild;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const width = this.dataset.full === undefined ? (slide?.clientWidth ?? track.clientWidth) + gap : track.clientWidth;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          if (dir > 0 && atEnd && this.hasAttribute('data-loop')) track.scrollTo({ left: 0, behavior: 'smooth' });
          else track.scrollBy({ left: dir * width, behavior: 'smooth' });
        };
        this.querySelector('[data-prev]')?.addEventListener('click', () => step(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => step(1));

        // Tap-to-play videos: one plays at a time.
        this.querySelectorAll('[data-video-card]').forEach((card) => {
          const video = card.querySelector('video');
          if (!video) return;
          card.addEventListener('click', () => {
            this.querySelectorAll('video').forEach((v) => v !== video && v.pause());
            if (video.paused) video.play(); else video.pause();
          });
          video.addEventListener('play', () => card.querySelector('[data-play]')?.classList.add('opacity-0'));
          video.addEventListener('pause', () => card.querySelector('[data-play]')?.classList.remove('opacity-0'));
        });
      }
    }
  );
}
